import React from 'react';
import { motion } from 'framer-motion';
import Icon from 'components/AppIcon';

export default function ScannerControls({ isScanning, isDetected, onCapture, onToggleFlash, onSearch, flashOn, onReset }) {
  return (
    <div className="absolute bottom-6 left-0 right-0 z-10 flex items-center justify-center gap-6 px-6">
      {/* Search / Manual */}
      <motion.button
        whileTap={{ scale: 0.9 }}
        onClick={onSearch}
        className="w-12 h-12 rounded-full bg-slate-800/80 border border-slate-600 flex items-center justify-center backdrop-blur-sm hover:border-cyan-500/50 transition-colors"
        aria-label="Manual product search"
      >
        <Icon name="Search" size={20} color="#94A3B8" />
      </motion.button>
      {/* Main capture button */}
      <motion.button
        whileTap={{ scale: 0.92 }}
        onClick={isDetected ? onReset : onCapture}
        className={`w-20 h-20 rounded-full flex items-center justify-center border-4 transition-all duration-300 ${
          isDetected
            ? 'bg-cyan-500 border-cyan-300 shadow-[0_0_24px_rgba(6,182,212,0.6)]'
            : isScanning
            ? 'bg-slate-700 border-cyan-500/60 shadow-[0_0_16px_rgba(6,182,212,0.3)]'
            : 'bg-slate-800 border-slate-500 hover:border-cyan-500/60'
        }`}
        aria-label={isDetected ? 'Reset scanner' : 'Capture product'}
      >
        {isDetected ? (
          <Icon name="RotateCcw" size={28} color="#0F172A" strokeWidth={2.5} />
        ) : isScanning ? (
          <div className="w-6 h-6 rounded-full border-2 border-cyan-400 border-t-transparent animate-spin" />
        ) : (
          <Icon name="Camera" size={28} color="#94A3B8" />
        )}
      </motion.button>
      {/* Flash toggle */}
      <motion.button
        whileTap={{ scale: 0.9 }}
        onClick={onToggleFlash}
        className={`w-12 h-12 rounded-full border flex items-center justify-center backdrop-blur-sm transition-colors ${
          flashOn
            ? 'bg-yellow-400/20 border-yellow-400/60' :'bg-slate-800/80 border-slate-600 hover:border-cyan-500/50'
        }`}
        aria-label="Toggle flash"
      >
        <Icon name={flashOn ? 'Zap' : 'ZapOff'} size={20} color={flashOn ? '#FBBF24' : '#94A3B8'} />
      </motion.button>
    </div>
  );
}